import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListService,
	setDetailService,
	GetListServiceAsyncPayload,
	getListServiceAsync,
	GetDetailServiceAsyncPayload,
	getDetailServiceAsync,
	CreateServiceAsyncPayload,
	createServiceAsync,
	UpdateServiceAsyncPayload,
	updateServiceAsync,
	UpdateStatusServiceAsyncPayload,
	updateStatusServiceAsync,
	changeStatusService,
	setLoadingService,
} from "./service.slice";
import { message } from "antd";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiResponse } from "types";
import { Service, ServiceDetail } from "../types";

// Get list
function* getListServiceSaga(
	action: PayloadAction<GetListServiceAsyncPayload>,
) {
	const { query, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Service[]>>(
				"/dashboard/services",
				{
					...query,
					skip: query.skip * query.take,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListService.type, payload: response });
	} else {
		message.error(translate(error.message));
	}

	callback && callback();
}
function* watchGetListService() {
	yield takeLatest(getListServiceAsync, getListServiceSaga);
}

// Detail
function* getDetailServiceSaga(
	action: PayloadAction<GetDetailServiceAsyncPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<ServiceDetail>>(
				`/dashboard/services/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setDetailService.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetDetailService() {
	yield takeLatest(getDetailServiceAsync, getDetailServiceSaga);
}

// Create
function* createServiceSaga(action: PayloadAction<CreateServiceAsyncPayload>) {
	yield put({ type: setLoadingService.type, payload: true });
	const { data, returnSuccessStatus } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/dashboard/services", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		returnSuccessStatus(true);
		message.success(t`Create successful`);
	} else {
		message.error(error.message);
	}
	yield put({ type: setLoadingService.type, payload: false });
}
function* watchCreateService() {
	yield takeLatest(createServiceAsync, createServiceSaga);
}

// Update
function* updateServiceSaga(action: PayloadAction<UpdateServiceAsyncPayload>) {
	const { id, data } = action.payload;
	yield put({ type: setLoadingService.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(`/dashboard/services/${id}`, data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingService.type, payload: false });
}
function* watchUpdateService() {
	yield takeLatest(updateServiceAsync, updateServiceSaga);
}

// Update
function* updateStatusServiceSaga(
	action: PayloadAction<UpdateStatusServiceAsyncPayload>,
) {
	const { id, status, callback } = action.payload;
	yield put({ type: setLoadingService.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(`/dashboard/services/${id}`, {
				status,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Update successful`);
		yield put({
			type: changeStatusService.type,
			payload: {
				id,
				status,
			},
		});
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingService.type, payload: false });
}
function* watchUpdateStatusService() {
	yield takeLatest(updateStatusServiceAsync, updateStatusServiceSaga);
}

const customerSaga = [
	watchGetListService(),
	watchGetDetailService(),
	watchCreateService(),
	watchUpdateService(),
	watchUpdateStatusService(),
];
export default customerSaga;
